import { useAppSelector } from 'app/hooks';
import { selectCurrentUser } from 'features/auth/authSlice';
import { UserRoles } from 'features/auth/authTypes';
import React, { Fragment } from 'react';
import { Navigate } from 'react-router-dom';

interface ProtectedRouteWithRoleProps {
  children: React.ReactNode;
  requiredRoles: string[];
}

export const ProtectedRouteWithRole = ({ requiredRoles, children }: ProtectedRouteWithRoleProps) => {
  const user = useAppSelector(selectCurrentUser);

  if (user?.role === UserRoles.PDF_ONLY) {
    return <Navigate to='salesforce-home' />;
  }

  if (!user || !requiredRoles.includes(user.role)) {
    return <Navigate to='/' />;
  }

  return <Fragment>{children}</Fragment>;
};
